import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Configure, Index } from 'react-instantsearch';
import { ALGOLIA_INDEX_NAME } from 'commons/constants';
import { SearchCount, CATEGORY_INDEX_MAPPING } from '../../commons/helpers';
import ProductSearchCount from './ProductSearchCount';
import MenuButtonLabel from './MenuButtonLabel';
import useMobileSearchFiltersTitle from '../hooks/useMobileSearchFiltersTitle';
const MobileSearchFilters = t0 => {
  const $ = _c(54);
  const {
    expandableOpen,
    index,
    onIndexChange,
    searchState,
    setExpandableOpen
  } = t0;
  const searchTitle = useMobileSearchFiltersTitle(index);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classNames("md:hidden mobile-filters", {
      "mobile-filters--showTopBorder": true
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== expandableOpen || $[2] !== setExpandableOpen) {
    t2 = () => {
      setExpandableOpen(!expandableOpen);
    };
    $[1] = expandableOpen;
    $[2] = setExpandableOpen;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== expandableOpen) {
    t3 = classNames("flex-1 min-h-[3rem] space-x-1 flex items-center justify-center text-sm font-bold", {
      "mobile-filters__menu-expandable-button--open": expandableOpen
    });
    $[4] = expandableOpen;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== searchTitle) {
    t4 = <MenuButtonLabel title={searchTitle} />;
    $[6] = searchTitle;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = <div className="flex items-center divide-x divide-gray-light7"><button type="button" onClick={t2} className={t3} aria-label="Toggle filters">{t4}</button></div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = !expandableOpen;
  let t7;
  if ($[12] !== expandableOpen || $[13] !== t6) {
    t7 = classNames("mobile-filters__expandable relative -top-px", {
      "mobile-filters__expandable--open border-b border-gray-light6": expandableOpen,
      hidden: t6
    });
    $[12] = expandableOpen;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = ["*"];
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = ["item_availability<2", "visibility>0", "visibility<4"];
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== searchState.configure.facetFilters) {
    t10 = <Configure facets={t8} facetFilters={searchState.configure.facetFilters} numericFilters={t9} getRankingInfo={true} />;
    $[17] = searchState.configure.facetFilters;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== index || $[20] !== onIndexChange) {
    t11 = <ProductSearchCount title="Products" id={CATEGORY_INDEX_MAPPING.products} selectedOption={index} indexClick={onIndexChange} />;
    $[19] = index;
    $[20] = onIndexChange;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10 || $[23] !== t11) {
    t12 = <Index indexName={ALGOLIA_INDEX_NAME.PRODUCTS}>{t10}{t11}</Index>;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Index indexName={ALGOLIA_INDEX_NAME.CATEGORIES}><Configure numericFilters={["fk_store_id=1"]} facetFilters={["is_searchable:1"]} getRankingInfo={true} /></Index>;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = ["*"];
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== searchState.configure.facetFilters) {
    t15 = <Configure facets={t14} numericFilters="" facetFilters={searchState.configure.facetFilters} />;
    $[27] = searchState.configure.facetFilters;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== index || $[30] !== onIndexChange) {
    t16 = <SearchCount title="Customer Photos" id={CATEGORY_INDEX_MAPPING["customer photos"]} selectedOption={index} indexClick={onIndexChange} />;
    $[29] = index;
    $[30] = onIndexChange;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t15 || $[33] !== t16) {
    t17 = <Index indexName="customer_photos">{t15}{t16}</Index>;
    $[32] = t15;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Configure facets={["*"]} numericFilters="" facetFilters="" />;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== index || $[37] !== onIndexChange) {
    t19 = <Index indexName="reviews">{t18}<SearchCount title="Reviews" id={CATEGORY_INDEX_MAPPING.reviews} selectedOption={index} indexClick={onIndexChange} /></Index>;
    $[36] = index;
    $[37] = onIndexChange;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Configure numericFilters={["is_active=1", "show_in_search=1", "fk_store_id=1"]} />;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== index || $[41] !== onIndexChange) {
    t21 = <Index indexName={ALGOLIA_INDEX_NAME.STATIC_PAGES}>{t20}<SearchCount title="Pages" id={CATEGORY_INDEX_MAPPING.pages} selectedOption={index} indexClick={onIndexChange} /></Index>;
    $[40] = index;
    $[41] = onIndexChange;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] !== t12 || $[44] !== t17 || $[45] !== t19 || $[46] !== t21) {
    t22 = <div className="text-base text-gray font-normal">{t12}{t13}{t17}{t19}{t21}</div>;
    $[43] = t12;
    $[44] = t17;
    $[45] = t19;
    $[46] = t21;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] !== t22 || $[49] !== t7) {
    t23 = <div className={t7}>{t22}</div>;
    $[48] = t22;
    $[49] = t7;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] !== t23 || $[52] !== t5) {
    t24 = <div className={t1}>{t5}{t23}</div>;
    $[51] = t23;
    $[52] = t5;
    $[53] = t24;
  } else {
    t24 = $[53];
  }
  return t24;
};
MobileSearchFilters.propTypes = {
  expandableOpen: PropTypes.bool,
  setExpandableOpen: PropTypes.func,
  index: PropTypes.string,
  filtersState: PropTypes.shape({
    isMaterialFiltered: PropTypes.shape({
      Fabric: PropTypes.bool,
      Leather: PropTypes.bool,
      Wood: PropTypes.bool
    }),
    colorFiltered: PropTypes.shape({
      isFiltered: PropTypes.bool,
      currentColor: PropTypes.array
    }),
    isFiltered: PropTypes.bool,
    typeFiltered: PropTypes.shape({
      isFiltered: PropTypes.bool,
      currentType: PropTypes.string
    }),
    selectedFiltersList: PropTypes.array
  }),
  onIndexChange: PropTypes.func,
  searchState: PropTypes.shape({
    query: PropTypes.string,
    configure: {
      facetFilters: PropTypes.string,
      facets: PropTypes.array
    },
    hitsPerPage: 12,
    page: 1
  })
};
export default MobileSearchFilters;